var SEARCHTYPE_ALL = 0;
var SEARCHTYPE_PARTIAL_MATCH = 1;
var SEARCHTYPE_EXACH_MATCH = 2;
var SEARCHTYPE_C_EXACH_MATCH = 3;
var SEARCHTYPE_A_EXACH_MATCH = 4;

var TA_SHIP_NAME = "Motor Tanker Amphion";
const $ = window.$;
export default function Overlay(baseurl, usertoken) {
    "use strict";

    var thisOverlay = this;

    thisOverlay.baseURL = baseurl;
    if (usertoken === undefined)
        thisOverlay.token = null;
    else
        thisOverlay.token = usertoken;
}

Overlay.prototype.GetCausalNodeIdsForNode = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetCausalNodeIdsForNode?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetCausalNodeIdsForNode");
};

Overlay.prototype.GetChildNodeIdsForNode = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetChildNodeIdsForNode?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetChildNodeIdsForNode");
};

Overlay.prototype.GetChildLinkIdsForNode = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetChildLinkIdsForNode?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetChildLinkIdsForNode");

};

Overlay.prototype.GetParentLinkIdsForNode = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetParentLinkIdsForNode?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetParentLinkIdsForNode");
};

Overlay.prototype.GetAffectedNodeIdsForNode = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetAffectedNodeIdsForNode?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetAffectedNodeIdsForNode");

};

Overlay.prototype.GetNodeInfo = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetNodeInfo?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetNodeInfo");

};

Overlay.prototype.GetLinkInfo = function (modelId, linkId) {

    var dataUrl = this.baseURL + "/GetLinkInfo?mi=" + modelId + "&li=" + linkId;
    return this.GetDataFromServer(dataUrl, "GetLinkInfo");

};

Overlay.prototype.SetNodeValue = function (modelId, nodeId, jsonArrayOfContextIds, newValue, snapshotLabel) {


    var dataUrl = "";
    if (snapshotLabel == undefined || snapshotLabel == "")
        dataUrl = this.baseURL + "/SetNodeValue?mi=" + modelId + "&ni=" + nodeId + "&ci=" + JSON.stringify(jsonArrayOfContextIds) + "&nv=" + newValue;
    else
        dataUrl = this.baseURL + "/SetNodeValue?mi=" + modelId + "&ni=" + nodeId + "&ci=" + JSON.stringify(jsonArrayOfContextIds) + "&nv=" + newValue + "&sl=" + snapshotLabel;


    return this.GetSingleValueDataFromServer(dataUrl, "SetNodeValue");
};

Overlay.prototype.GetRootNodeId = function (modelId) {

    var dataUrl = this.baseURL + "/GetRootNodeId?mi=" + modelId;
    return this.GetSingleValueDataFromServer(dataUrl, "GetRootNodeId");
};

Overlay.prototype.GetNodesBySearch = function (modelId, searchType, searchText) {

    var dataUrl = this.baseURL + "/GetNodesBySearch?mi=" + modelId + "&stype=" + searchType + "&stext=" + searchText;
    return this.GetDataFromServer(dataUrl, "GetNodesBySearch");
};

Overlay.prototype.GetAncestors = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetAncestors?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetAncestors");
};

Overlay.prototype.GetReferencedNodeIdsForNode = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetReferencedNodeIdsForNode?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetReferencedNodeIdsForNode");

};

Overlay.prototype.GetQuarantineNodeId = function (modelId) {

    var dataUrl = this.baseURL + "/GetQuarantineNodeId?mi=" + modelId;
    return this.GetSingleValueDataFromServer(dataUrl, "GetQuarantineNodeId");
};

Overlay.prototype.GetNodeValueViaContextResolution = function (modelId, nodeId, jsonArrayOfContextIds) {

    var dataUrl = this.baseURL + "/GetNodeValueViaContextResolution?mi=" + modelId + "&ni=" + nodeId + "&ci=" + JSON.stringify(jsonArrayOfContextIds);
    return this.GetSingleValueDataFromServer(dataUrl, "GetNodeValueViaContextResolution");
};

Overlay.prototype.GetSessionLogEntries = function (modelId, sessionId) {

    var dataUrl = this.baseURL + "/GetSessionLogEntries?mi=" + modelId + "&si=" + sessionId;
    return this.GetDataFromServer(dataUrl, "GetSessionLogEntries");
};

Overlay.prototype.AddContextLabelEx = function (modelId, nodeId, contextLabelName, contextLabelId) {

    var dataUrl = this.baseURL + "/AddContextLabelEx?mi=" + modelId + "&ni=" + nodeId + "&lid=" + contextLabelId + "&cln=" + contextLabelName;
    return this.GetSingleValueDataFromServer(dataUrl, "AddContextLabel");
};

Overlay.prototype.AddContextLabel = function (modelId, nodeId, contextLabelName) {

    var dataUrl = this.baseURL + "/AddContextLabel?mi=" + modelId + "&ni=" + nodeId + "&cln=" + contextLabelName;
    return this.GetSingleValueDataFromServer(dataUrl, "AddContextLabel");
};

Overlay.prototype.GetContextLabelsBySearch = function (modelId, searchType, searchText) {

    /* ******** Type of Context Label Match *****************
        
        0: Get all context labels
        1; Get context label which contains the search term
        2: Get context label which match the search term exactly

    ******** Type of Context Label Match ***************** */


    var dataUrl = this.baseURL + "/GetContextLabelsBySearch?mi=" + modelId + "&stype=" + searchType + "&stext=" + searchText;

    return this.GetDataFromServer(dataUrl, "GetContextLabelsBySearch");
};

Overlay.prototype.GetNodeIdbyUniqueName = function (modelId, nodeUniqueName) {

    var dataUrl = this.baseURL + "/GetNodeIdbyUniqueName?mi=" + modelId + "&un=" + nodeUniqueName;
    return this.GetSingleValueDataFromServer(dataUrl, "GetNodeIdbyUniqueName");
};

Overlay.prototype.SetNodeValueExtended = function (modelId, jsonArrayofNodeValues, snapshotLabel) {

    var dataUrl = "";

    if (snapshotLabel == undefined || snapshotLabel == "")
        dataUrl = this.baseURL + "/SetNodeValueExtended?mi=" + modelId + "&nv=" + JSON.stringify(jsonArrayofNodeValues);
    else
        dataUrl = this.baseURL + "/SetNodeValueExtended?mi=" + modelId + "&nv=" + JSON.stringify(jsonArrayofNodeValues) + "&sl=" + snapshotLabel;

    return this.GetSingleValueDataFromServer(dataUrl, "SetNodeValueExtended");
};

Overlay.prototype.GetHostedModelId = function () {

    var dataUrl = this.baseURL + "/GetHostedModelId";
    return this.GetSingleValueDataFromServer(dataUrl, "GetHostedModelId");
};

Overlay.prototype.GetNodeInfoByUniqueName = function (modelId, nodeUniqueName) {

    var dataUrl = this.baseURL + "/GetNodeInfoByUniqueName?mi=" + modelId + "&nv=" + nodeUniqueName;
    return this.GetSingleValueDataFromServer(dataUrl, "GetNodeInfoByUniqueName");
};

Overlay.prototype.GetNodeInfoEx = function (modelId, jsonArrayofNodeIds) {

    var dataUrl = this.baseURL + "/GetNodeInfoEx?mi=" + modelId + "&nv=" + JSON.stringify(jsonArrayofNodeIds);
    return this.GetDataFromServer(dataUrl, "GetNodeInfoEx");
};

Overlay.prototype.GetNodeContexts = function (modelId, nodeId) {

    var dataUrl = this.baseURL + "/GetNodeContexts?mi=" + modelId + "&ni=" + nodeId;
    return this.GetDataFromServer(dataUrl, "GetNodeContexts");
};

Overlay.prototype.GetNodeValueInstances = function (modelId, nodeId, jsonArrayOfContextIds, searchType) {

    var dataUrl = this.baseURL + "/GetNodeValueInstances?mi=" + modelId + "&ni=" + nodeId + "&ci=" + jsonArrayOfContextIds + "&stype=" + searchType;
    return this.GetDataFromServer(dataUrl, "GetNodeValueInstances");
};

Overlay.prototype.getIdentificationAttributeJSONForNodeInstance = function (modelId, identificationNodeId, nodeInstanceId) {

    var dataUrl = this.baseURL + "/getIdentificationAttributeJSONForNodeInstance?mi=" + modelId + "&iid=" + identificationNodeId + "&nid=" + nodeInstanceId;
    return this.GetDataFromServer(dataUrl, "getIdentificationAttributeJSONForNodeInstance");
};

Overlay.prototype.getInstanceInfoJSONViaIdentificationAttribute = function (modelId, nodeId, jsonArrayOfIdentificationContextIds) {

    var dataUrl = this.baseURL + "/getInstanceInfoJSONViaIdentificationAttribute?mi=" + modelId + "&ni=" + nodeId + "&ci=" + jsonArrayOfIdentificationContextIds;
    return this.GetDataFromServer(dataUrl, "getInstanceInfoJSONViaIdentificationAttribute");
};

Overlay.prototype.SetContextLabelIdentificationNodeInstances = function (modelId, contextLabelId, jsonArrayOfIdentificationInstanceIds) {

    var dataUrl = this.baseURL + "/SetContextLabelIdentificationNodeInstances?mi=" + modelId + "&ci=" + contextLabelId + "&i=" + jsonArrayOfIdentificationInstanceIds;
    return this.GetSingleValueDataFromServer(dataUrl, "SetContextLabelIdentificationNodeInstances");
};

Overlay.prototype.getIdentificationNodeJSONForNodeInstance = function (modelId, nodeInstanceId) {

    var dataUrl = this.baseURL + "/getIdentificationNodeJSONForNodeInstance?mi=" + modelId + "&nid=" + nodeInstanceId;
    return this.GetDataFromServer(dataUrl, "getIdentificationNodeJSONForNodeInstance");
};

Overlay.prototype.EraseInstance = function (modelId, nodeOrLinkId, jsonArrayOfContextIds) {

    var dataUrl = this.baseURL + "/EraseInstance?mi=" + modelId + "&ni=" + nodeOrLinkId + "&ci=" + jsonArrayOfContextIds;
    return this.GetDataFromServer(dataUrl, "EraseInstance");
};

Overlay.prototype.GetDataFromServer = function (url, methodName) {

    var returnData;
    var isSuccess;
    var thisOverlay = this;

    //check for token
    if (thisOverlay.token != null)
        //if (url.includes("GetHostedModelId") == true)
        if (url.indexOf("GetHostedModelId") > -1)
            url = url + "?ut=" + encodeURIComponent(thisOverlay.token);
        else
            url = url + "&ut=" + encodeURIComponent(thisOverlay.token);



	




    $.ajax({
        url: url,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        async: false,
        success: function (data) {

            if ("undefined" === typeof (data[methodName + "Result"])) {
                returnData = "";
            } else {
                var jsonData = (data[methodName + "Result"]) ? JSON.parse(data[methodName + "Result"]) : "";
                returnData = jsonData;
            }

            isSuccess = (returnData == "") ? false : true;
        },
        error: function (data) {
            isSuccess = false;
            returnData = "";//data;
            //alert("failed to read data from server!");
        }
    });
	
	
	
	
	
	

    return { success: isSuccess, data: returnData };
};

Overlay.prototype.GetSingleValueDataFromServer = function (url, methodName) {
    var bypass=false;
    var returnData;
	var returnData1;
    var isSuccess;
    var thisOverlay = this;

    //check for token
    if (thisOverlay.token != null)

        if (url.indexOf("GetHostedModelId") > -1)
            url = url + "?ut=" + encodeURIComponent(thisOverlay.token);
        else
            url = url + "&ut=" + encodeURIComponent(thisOverlay.token);
if (bypass){
         sendRequest(url,function (reqdata) { 
		 
		 returnData=JSON.parse(reqdata.response)[methodName + "Result"];
		 isSuccess=true;
	
		 
		 },""
		 
		 
		 );
}
else{
	
    $.ajax({
        url: url,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        async: false,
        success: function (data) {

            returnData = eval("data." + methodName + "Result");
            isSuccess = true;

        },
        error: function (data) {
            isSuccess = false;
            returnData = "";
            
        }
    });
}
     
    return { success: isSuccess, data: returnData };
};
////===========================================================
function sendRequest(url,callback,postData) {
    var req = createXMLHTTPObject();
    if (!req) return;
    var method = (postData) ? "POST" : "POST";
    req.open(method,url,false);
  //  req.setRequestHeader('User-Agent','XMLHTTP/1.0');
    if (postData)
        req.setRequestHeader('Content-type','application/json; charset=utf-8');
    req.onreadystatechange = function () {
        if (req.readyState != 4) return;
        if (req.status != 200 && req.status != 304) {

            return;
        }
        callback(req);
    }
    if (req.readyState == 4) return;
    req.send(postData);
}

var XMLHttpFactories = [
    function () {return new XMLHttpRequest()},
    function () {return new window.ActiveXObject("Msxml2.XMLHTTP")},
    function () { return new window.ActiveXObject("Msxml3.XMLHTTP")},
    function () { return new window.ActiveXObject("Microsoft.XMLHTTP")}
];

function createXMLHTTPObject() {
    var xmlhttp = false;
    for (var i=0;i<XMLHttpFactories.length;i++) {
        try {
            xmlhttp = XMLHttpFactories[i]();
        }
        catch (e) {
            continue;
        }
        break;
    }
    return xmlhttp;
}



// WEBPACK FOOTER //
// ./src/components/Utils/js-bridge/overlay.js